import { track } from '@/services/tracking'

// Call track for inputs with errors from vee-validate fields
export default function trackErrors (validationObj, module) {
  for (var property in validationObj.fields) {
    const hasError = validationObj.fields[property] ? validationObj.fields[property].invalid : null

    if (hasError) {
      if (property === 'given_name') {
        property = 'first_name'
      }

      if (property === 'family_name') {
        property = 'last_name'
      }

      // TODO: Bring back error_message when we can access errors
      track({ name: `${module} failed`, params: { description: property, module } })
    }
  }
}
